import { HttpHeaders, HttpParams } from "@angular/common/http";
import { Router } from "@angular/router";
import {
  Component,
  OnInit,
  Input,
  Output,
  SimpleChanges,
  EventEmitter,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { ServiciosService } from "src/app/core/services/servicios.service";
import { FlujoService } from "src/app/core/services/flujos.service";
import { lastValueFrom, takeUntil, Subject } from "rxjs";
import Swal, { SweetAlertIcon } from "sweetalert2";
import { k } from "src/environments/properties";

@Component({
  selector: "app-flujo",
  templateUrl: "./flujo.component.html",
  styleUrls: ["./flujo.css"],
})
export class FlujoComponent implements OnInit {
  private destroy$ = new Subject<void>();

  public formServiciosBucket: FormGroup;
  public closeResult: string = "";
  spinner: boolean = false;
  toast = Swal;
  idBucket: number = 0;
  idServicio: string = "";
  isEditMode = false;
  formServiciosBucketIsSubmited = false;

  @Input() idBucketP: number = 0;
  @Input() idBucketDefault: number = 0;
  @Output() saved = new EventEmitter<any>();
  @Output() close = new EventEmitter<any>();

  constructor(
    private seriviciosServices: ServiciosService,
    private flujoservice: FlujoService,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private route: ActivatedRoute,
  ) {}

  async ngOnInit() {
    this.toastAlert();
    this.initUserForm();

    this.route.paramMap.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      const id = params.get("id");
      // const idBucket = params.get("id_bucket");

      if (id && this.idBucketP) {
        this.idServicio = id;
        this.idBucket = this.idBucketP;

        // this.showBucket();
      }
    });
  }

  async ngOnChanges(changes: SimpleChanges) {
    if (changes["idBucketP"] && this.idBucketP) {
      const idServicio = this.route.snapshot.paramMap.get("id");

      if (!idServicio) {
        return;
      }

      this.idServicio = idServicio;
      this.idBucket = this.idBucketP;

      await this.showBucket();
    }
  }

  ngAfterViewInit(): void {}

  async crearServicioBucket() {
    //const idServicio = this.route.snapshot.paramMap.get("id");
    this.idServicio = this.route.snapshot.paramMap.get("id");

    this.formServiciosBucketIsSubmited = true;
    if (!this.formServiciosBucket.valid) {
      this.formServiciosBucket.markAllAsTouched();
      return false;
    }

    const formValue = this.formServiciosBucket.getRawValue();
    const { es_predeterminado, ...bucketData } = formValue;
    const payload = {
      ...bucketData,
    };

    try {
      let response = await lastValueFrom(
        this.seriviciosServices.crearFlujo(payload, this.idServicio),
      );

      this.idBucket = response.id;
      if (formValue.es_predeterminado === true) {
        response = await this.establecerBucketPredeterminado(response.id);
      }

      this.alert("success", "Éxito!", "Flujo Registrado!");
      this.saved.emit(response);
    } catch (error) {
      console.error("Error al crear configuración del flujo:", error);
    }

    this.formServiciosBucketIsSubmited = false;
  }

  async CloseModal() {
    this.close.emit();
  }

  async editarServicioBucket() {
    this.formServiciosBucketIsSubmited = true;
    if (!this.formServiciosBucket.valid) {
      this.formServiciosBucket.markAllAsTouched();
      return false;
    }

    const formValue = this.formServiciosBucket.getRawValue();
    const { es_predeterminado, ...bucketData } = formValue;
    const payload = {
      ...bucketData,
    };

    try {
      const response = await lastValueFrom(
        this.seriviciosServices.updFlujo(
          payload,
          this.idServicio,
          this.idBucketP,
        ),
      );

      this.idBucket = response.id;
      if (formValue.es_predeterminado === true) {
        await this.establecerBucketPredeterminado(response.id);
      }

      this.alert("success", "Éxito!", "Flujo actualizado!");
      this.saved.emit(response);
    } catch (error) {
      console.error("Error al crear configuración del flujo:", error);
    }
    this.formServiciosBucketIsSubmited = false;
  }

  async showBucket() {
    const response = await lastValueFrom(
      this.seriviciosServices.showFlujo(this.idServicio, this.idBucketP),
    );
    const servicioBucket = response.body;
    this.isEditMode = true;
    if (!servicioBucket) return;

    this.formServiciosBucket.patchValue({
      nombre: servicioBucket.nombre,
      descripcion: servicioBucket.descripcion,
      endpoint: servicioBucket.endpoint,
      es_predeterminado: this.idBucket == this.idBucketDefault ? true : false,
      plantilla_precalibrada: servicioBucket.plantilla_precalibrada
    });
  }

  guardarServicioBucket() {
    if (this.isEditMode) {
      this.editarServicioBucket();
    } else {
      this.crearServicioBucket();
    }
  }

  async establecerBucketPredeterminado(idBucket: number): Promise<void> {
    

    try {
      const payload = {
        id_servicio_externo_flujo_predeterminado: idBucket,
      };

      await lastValueFrom(
        this.seriviciosServices.editarServicio(payload, this.idServicio),
      );
    } catch (error) {
      console.error("Error al establecer flujo predeterminado:", error);

      throw error;
    }
  }

  initUserForm(): void {
    this.formServiciosBucket = this.fb.group({
      nombre: ["", [Validators.required, Validators.minLength(2)]],
      descripcion: ["", [Validators.required, Validators.minLength(3)]],
      endpoint: ["", [Validators.required, Validators.minLength(3)]],
      es_predeterminado: ["false", []],
      plantilla_precalibrada: ["false", []],
    });
  }

  openModalContent(
    content: any,
    mode: boolean,
    size: "sm" | "lg" | "xl" = "lg",
    windowClass?: string,
  ) {
    this.modalService
      .open(content, {
        ariaLabelledBy: "modal-basic-title",
        size,
        centered: true,
        windowClass,
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        },
      );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  //  FIN METODOS PARA EL BUCKET

  toastAlert() {
    this.toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });
  }

  alert(icontext: SweetAlertIcon, title: string, text: string = "") {
    this.toast.fire({
      icon: icontext,
      title: title,
      text: text,
    });
  }
}
